<template>
	<form class="vn-form create-warehouse" @submit.prevent="openModal">
		<section class="vn-form-section">
			<header><span class="vn-step">۱</span><div><h2>مشخصات کالا</h2><p>نام، کد و نوع کالا در گزارش‌ها و انبارها همین‌طور دیده می‌شود.</p></div></header>
			<div class="vn-form-grid">
				<div class="vn-field"><label for="ware-fa">نام فارسی</label><input id="ware-fa" v-model="faName" class="inputs" required /></div>
				<div class="vn-field"><label for="ware-en">نام انگلیسی</label><input id="ware-en" v-model="enName" class="inputs" dir="ltr" required /></div>
				<div class="vn-field"><label for="ware-code">کد کالا</label><input id="ware-code" v-model="productCode" class="inputs" dir="ltr" required /></div>
				<div class="vn-field">
					<label for="ware-type">نوع کالا</label>
					<select id="ware-type" v-model="productType" class="form-select" required>
						<option :value="null" disabled>انتخاب کنید</option>
						<option v-for="types in wareType" :value="types.id" :key="types.id">{{ types.verbose_name }}</option>
					</select>
				</div>
				<div class="vn-field">
					<label for="ware-unit">واحد اندازه‌گیری</label>
					<select id="ware-unit" v-model="unit" class="form-select">
						<option :value="null" disabled>انتخاب کنید</option>
						<option v-for="measurment in wareMeasurment" :value="measurment.id" :key="measurment.id">{{ measurment.unit_fa }}</option>
					</select>
				</div>
				<div class="vn-field wide"><label for="ware-desc">توضیحات</label><textarea id="ware-desc" v-model="textareaProduct" rows="3" placeholder="اختیاری"></textarea></div>
			</div>
		</section>
		<section class="vn-form-section">
			<header><span class="vn-step">۲</span><div><h2>مصرف در ویزیت</h2><p>کالای مصرفی در ویزیت‌های انتخاب‌شده از موجودی نیروی اجرایی کم می‌شود.</p></div></header>
			<label class="vn-check"><input v-model="checkBox" type="checkbox" />این کالا مصرفی است</label>
			<div v-if="checkBox" class="vn-chips mt-3" role="group" aria-label="نوع ویزیت‌ها">
				<label v-for="visit in visitTypeList" :key="visit.id"><input v-model="selected" type="checkbox" :value="visit.id" />{{ visit.verbose_name }}</label>
			</div>
			<p v-if="checkBox && !selected.length" class="hint mt-2">دست‌کم یک نوع ویزیت را انتخاب کنید.</p>
		</section>
		<div class="vn-form-actions">
			<span class="note">پس از ثبت، انبار و موجودی اولیه را انتخاب می‌کنید.</span>
			<router-link :to="{ name: 'listWareHouse' }" class="btn btn-outline-primary">انصراف</router-link>
			<button type="submit" :disabled="checkEmpty" class="accept">ادامه</button>
		</div>
		<b-modal v-model="modal" title="موجودی اولیه" hide-footer centered header-close-label="بستن">
			<div class="vn-form-grid">
				<div class="vn-field">
					<label for="ware-location">انبار</label>
					<select id="ware-location" v-model="pickLocation" class="form-select">
						<option value="" disabled>انتخاب کنید</option>
						<option v-for="location in locationLists" :value="location.id" :key="location.id">{{ location.name_fa }}</option>
					</select>
				</div>
				<div class="vn-field"><label for="ware-qty">مقدار</label><input id="ware-qty" v-model="useInputValue" class="inputs" type="number" min="1" /></div>
			</div>
			<div class="detail-form-actions mt-4">
				<button type="button" class="remove-filtes" @click="modal = false">انصراف</button>
				<button type="button" @click="postData" :disabled="checkModalEmpty" class="accept">ثبت کالا</button>
			</div>
		</b-modal>
	</form>
</template>
<script>
// import Tableview from '../../components/Tableview/index.vue';

export default {
	data() {
		return {
			enName: null,
			faName: null,
			productCode: null,
			textareaProduct: null,
			// textareaTransaction: null,
			checkBox: false,
			wareType: [],
			productType: null,
			unit: null,
			visitTypeList: [],
			selected: [],
			wareMeasurment: [],
			modal: false,
			pickLocation: '',
			locationLists: [],
			useInputValue: null,
			wareId: null,
		};
	},
	mounted() {
		this.getWareType();
		this.getVisitType();
		this.getWareMeasurement();
	},
	computed: {
		checkEmpty() {
			if (
				this.enName === null ||
				this.enName === '' ||
				this.faName === null ||
				this.faName === '' ||
				this.productCode === null ||
				this.productCode === '' ||
				this.productType === null ||
				false
			) {
				return true;
			} else {
				if (this.checkBox === true) {
					if (this.selected.length === 0) {
						return true;
					} else {
						return false;
					}
				} else {
					return false;
				}
			}
		},
		checkModalEmpty() {
			if (
				this.useInputValue === null ||
				this.useInputValue === '' ||
				this.pickLocation === null ||
				this.pickLocation === '' 
			) {
				return true;
			} else {
				return false;
			}
		},
	},
	methods: {
		async getWareType() {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.MULTI.WAREHOUSE_TYPE +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.EMPTY,
			);
			if (res.status === 200) {
				this.wareType = res.data;
			}
		},
		async getWareMeasurement() {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.MULTI.UNIT_LIST_CREATE +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.EMPTY,
			);
			if (res.status === 200) {
				this.wareMeasurment = res.data;
			}
		},
		async postData() {
			console.log('se:', this.selected);
			const data = {
				name_en: this.enName,
				name_fa: this.faName,
				is_for_use: this.checkBox,
				description: this.textareaProduct,
				type: this.productType,
				identifier: this.productCode,
				unit: this.unit,
				project: this.$STORE.state.userConfig.setProjectId,
			};
			const res = await this.$ApiServiceLayer.post(
				this.$PATH.RELATIVE_PATH.MULTI.WAREHOUSE_LIST_CREATE +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.EMPTY,
				data,
			);
			if (res.status === 201) {
				this.wareId = res.data.id;
				const data = {
					lines: [
						{
							ware: this.wareId,
							amount: parseInt(this.useInputValue * -1),
							location: null,
							user: null,
							side: 'FROM',
							involved: null,
						},
						{
							ware: this.wareId,
							amount: parseInt(this.useInputValue),
							location: this.pickLocation,
							user: null,
							side: 'TO',
							involved: 'LOCATION',
						},
					],
					description: `ایجاد ${this.useInputValue} عدد در انبار`,
				};
				const res1 = await this.$ApiServiceLayer.post(
					this.$PATH.RELATIVE_PATH.POST.WARE_TRANSACTION +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
					this.$PATH.SERVICE_NAME.EMPTY,
					data,
				);
				if (res1.status === 200) {
					if (this.checkBox === true) {
						let lists = [];
						if (this.selected.length > 0) {
							for (let i of this.selected) {
								lists.push({
									ware: this.wareId,
									visit_type: i,
								});
							}
						}
						const res2 = await this.$ApiServiceLayer.post(
							this.$PATH.RELATIVE_PATH.MULTI.WARE_VISIT_TYPE +
								'?p=' +
								this.$STORE.state.userConfig.setProjectId,
							this.$PATH.SERVICE_NAME.EMPTY,
							lists,
						);
						if (res2.status === 201) {
							this.$router.push({ name: 'listWareHouse' });
						}
					} else {
						this.$router.push({ name: 'listWareHouse' });
					}
				}
			}
		},
		async getVisitType() {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.VISIT_TYPE + '?p=' + this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.visitTypeList = res.data;
			}
		},
		async getLocationLists() {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.MULTI.LOCATION_LIST_CREATE +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.EMPTY,
			);
			if (res.status === 200) {
				this.locationLists = res.data;
			}
		},
		openModal() {
			if (this.checkEmpty) return;
			this.modal = true;
			this.getLocationLists();
		},
	},
};
</script>
<style scoped>
.create-warehouse { max-width: 980px; }
</style>
